module.exports = __webpack_public_path__ + "static/media/VestasSans-Heavy.b1d59063.woff";